"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleHeaderVideo = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../../../dsl/front");
const PlayIcon_1 = require("../../PlayIcon");
const VideoPlayer_1 = __importDefault(require("../../VideoPlayer/VideoPlayer"));
let ArticleHeaderVideo = class ArticleHeaderVideo extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isPlayerFloating = false;
        this.isPlayerInitialised = false;
        this.videoAttrId = this.$id() + 'video';
        this.videoHeight = 300;
        this.scrollObserver = null;
        this.baseVideoProps = {
            shouldInit: this.noThumbnail,
            videoAttrId: this.videoAttrId,
            eventBus: this.eventBus,
            baseVideoMetadata: this.baseVideoMetadata
        };
    }
    get hasYTVideo() {
        return typeof this.video.url === 'string' && this.video.url.length > 0;
    }
    get hasFileVideo() {
        return typeof this.video.file === 'object' && (!!this.video.file.url || !!this.video.file.m3u8);
    }
    /**
     * Handles the `@click` event on the "close" button.
     */
    onCloseBtnClick() {
        this.eventBus.emit('ui:video-player.pause', {
            playerId: this.videoAttrId
        });
        this.unobservePlayerVisibility();
    }
    /**
     * Handles the `@click` event on the "play" button.
     */
    onPlayBtnClick() {
        this.eventBus.emit('ui:video-player.play', {
            playerId: this.videoAttrId,
            autoplay: true
        });
    }
    onVideoInit() {
        this.observePlayerVisibility();
        this.isPlayerInitialised = true;
    }
    /**
     * Observes the player's visibility and react accordingly.
     */
    observePlayerVisibility() {
        if (!this.$refs.videoWrapper || !this.scrollObserver) {
            return;
        }
        this.videoHeight = this.$refs.videoWrapper.offsetTop * 0.50;
        this.scrollObserver.observe(this.$refs.videoWrapper);
    }
    /**
     * Stops the floating of the player and returns it to its original position.
     */
    unobservePlayerVisibility() {
        this.isPlayerFloating = false;
        // if (this.scrollObserver) {
        //   this.scrollObserver.disconnect()
        // }
    }
    toggleFloating(isFloating) {
        this.isPlayerFloating = isFloating;
    }
};
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: true
    }),
    __metadata("design:type", Object)
], ArticleHeaderVideo.prototype, "eventBus", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: true
    }),
    __metadata("design:type", Object)
], ArticleHeaderVideo.prototype, "baseVideoMetadata", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: true
    }),
    __metadata("design:type", Object)
], ArticleHeaderVideo.prototype, "video", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: false
    }),
    __metadata("design:type", Object)
], ArticleHeaderVideo.prototype, "videoSettings", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Boolean,
        required: false,
        default: false
    }),
    __metadata("design:type", Boolean)
], ArticleHeaderVideo.prototype, "noThumbnail", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: String,
        required: true
    }),
    __metadata("design:type", String)
], ArticleHeaderVideo.prototype, "siteDomain", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: String,
        required: false
    }),
    __metadata("design:type", String)
], ArticleHeaderVideo.prototype, "videoAdsTag", void 0);
ArticleHeaderVideo = __decorate([
    vue_property_decorator_1.Component({
        name: 'ArticleHeaderVideo',
        components: {
            BootstrapButton: front_1.BootstrapButton,
            BootstrapIcon: front_1.BootstrapIcon,
            PlayIcon: PlayIcon_1.PlayIcon,
            VideoPlayer: VideoPlayer_1.default
        },
        mounted() {
            let topLimit = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--navbar-height'), 10);
            if (!topLimit) {
                topLimit = 140;
            }
            topLimit = 345;
            this.scrollObserver = new IntersectionObserver((entries) => {
                const outOfViewport = entries.find((entry) => !entry.isIntersecting);
                // float only if player is out of viewport and is above current scroll position (in case it doesn't fit in viewport because of an ad or banner)
                this.toggleFloating(!!outOfViewport && outOfViewport.target.getBoundingClientRect().top <= (topLimit));
                // if (outOfViewport) {
                // console.log('outOfViewport', outOfViewport.target.getBoundingClientRect().top, '<=', (topLimit))
                // }
                // this.toggleFloating(!this.isPlayerFloating)
            }, {
                rootMargin: `${-(topLimit)}px 0px 0px 0px`,
                threshold: [0, 1]
            });
            setTimeout(() => {
                this.eventBus.emit('ui:video-player.play', {
                    playerId: this.videoAttrId,
                    autoplay: true,
                    muted: true
                });
            }, 500);
        },
        beforeDestroy() {
            if (this.scrollObserver) {
                this.scrollObserver.disconnect();
            }
        },
        template: `
    <div class="article-header__image__yt-embed__wrapper" ref="videoWrapper">
    <!-- "Play" button -->
    <BootstrapButton @click="onPlayBtnClick"
                     class="article-header__image__play-btn p-0 shadow-none" aria-label="Odtwórz">
      <PlayIcon/>
    </BootstrapButton>

    <!-- YT embed -->
    <div class="article-header__image__yt-embed"
         :class="{ '--hidden': !isPlayerInitialised, '--floating': isPlayerFloating }">
      <!-- Player -->

      <VideoPlayer class="article-header__image__yt-embed__player"
                   :video="video"
                   :noThumbnail="noThumbnail"
                   :videoSettings="videoSettings"
                   :baseVideoMetadata="baseVideoMetadata"
                   :videoAttrId="videoAttrId"
                   :videoAdsTag="videoAdsTag"
                   :origin="siteDomain"
                   @init="onVideoInit"/>

      <!-- "Close" button -->
      <BootstrapButton class="article-header__image__yt-embed__close-btn btn-primary btn-square btn-sm"
                       @click="onCloseBtnClick" :class="{ 'd-none': !isPlayerFloating }">
        <BootstrapIcon name="close" size="small"/>
        <span class="visually-hidden">{{ $t('_.close') }}</span>
      </BootstrapButton>
    </div>
    <!-- END | YT embed -->
    </div>
  `
    })
], ArticleHeaderVideo);
exports.ArticleHeaderVideo = ArticleHeaderVideo;
exports.default = ArticleHeaderVideo;
//# sourceMappingURL=ArticleHeaderVideo.js.map